import React, { Component } from 'react'
import PropTypes from 'prop-types'
import store from 'config/store/'
import { dataset } from 'config/types/dataset'
import { createToken, updateStore } from 'actions/tokenAction'
import { saveEmail } from 'actions/emailAction'
import * as validates from 'services/validations'
import onSubmitInfoMapping from 'services/onSubmitInfoMapping'
import getDataAttributeById from 'services/getDataAttributeById'
import trackingEvents from 'services/trackingEvents'
import Input from 'components/shared/form/Input'

class BaseForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      errors: null,
      success: null
    }
  }

  UNSAFE_componentWillMount() {
    if (this.props.status) {
      this.setStateToSuccess()
    }
  }

  UNSAFE_componentWillReceiveProps(props) {
    this.setState({ success: props.show_success })
  }

  isValid() {
    validates.EmailOf(this.state.email)

    if (validates.hasErrors()) {
      this.setState({ errors: true })
      trackingEvents().notValidEmail()
      return false;
    }
    return true;
  }

  handleInputChange(event) {
    this.setState({ [event.target.name]: event.target.value, errors: null })
  }

  clearErrors() {
    this.setState({ errors: null })
  }

  clearSuccess() {
    this.setState({ success: null })
  }

  onSubmit(event) {
    event.preventDefault()

    const document_file_name = onSubmitInfoMapping(window.finanztip && window.finanztip.documentFileName);
    const document_url = window.finanztip && window.finanztip.documentUrl;
    if (window.finanztip && window.finanztip.documentFileName) {
      window.finanztip.documentFileName = undefined;
    }

    if (event.target.elements[2] && event.target.elements[2].name === 'resend-button') {
      return null;
    }

    if (this.isValid()) {
      let that = this,
        subscription_source = getDataAttributeById(this.props.mainId, dataset.subscription_source) || null

      if (document_file_name) {
        subscription_source = 'newsletter_document-download'
      }

      store.dispatch(
        createToken(this.state.email, document_file_name, document_url, subscription_source)
      ).then((response) => {

        this.clearInputValues()
        store.dispatch(saveEmail(that.state.email))

        if (response.status === 201) {
          this.props.changeFormSuccess('new')
          localStorage.setItem('container', that.props.container)
          that.setStateToSuccess()
          store.dispatch(updateStore(response, subscription_source))
        }

        if (response.status === 200 && response.data.doi) {
          this.props.changeFormSuccess('doi')
          localStorage.setItem('container', that.props.container)
          that.setStateToSuccess(true)
          store.dispatch(updateStore(response, subscription_source))
        }

        if (response.status === 200 && !response.data.doi) {
          this.props.changeFormSuccess('soi')
          store.dispatch(updateStore(response, subscription_source))
        }
      })

    }
  }

  setStateToSuccess(doi) {
    this.setState({
      email: "",
      success: true,
      doi: doi ? true : false
    })
  }

  clearInputValues() {
    let fields = document.querySelectorAll('[name=email]')

    fields.forEach(function (field) {
      field.value = ''
    })
  }

  render() {
    return (
      <form className="row margin-top-s" onSubmit={this.onSubmit.bind(this)} noValidate>
        <div className="col-sm-3" style={{ display: this.state.success ? 'none' : null }}>
          <Input
            type="email"
            name="email"
            classes={this.props.classes}
            placeholder={this.props.placeholder}
            onChange={this.handleInputChange.bind(this)}
            value={this.state.email}
          />
        </div>
        <div className="col-sm-2" style={{ display: this.state.success ? 'none' : null }}>
          <button className="primary" >{this.props.button_name}</button>
        </div>
        <div className="col-sm-12"></div>
      </form>
    )
  }
}

BaseForm.propTypes = {
  button_name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  mainId: PropTypes.string.isRequired
}

export default BaseForm
